import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-left: 10px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;

export const HeaderTitle = styled.div`
  flex-grow: 1;
`;

export const HeaderRight = styled.div`
  display: flex;
  flex-grow: 3;
`;

export const SubHeader = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export const ContainerBody = styled.div`
  display: flex;
  flex: 1;
  gap: 20px;
  @media only screen and (max-width: 1500px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ContainerBodyLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 4;
  margin: 10px;
  gap: 10px;
`;

export const ContainerBodyRight = styled.div`
  display: flex;
  flex-grow: 1;
  background: white;
  border-radius: 4px;
  margin: 10px;
`;

export const CloseIcon = styled.img`
  width: 14px;
  align-self: flex-end;
`;

export const CardContainer = styled.div`
  width: 100%;

  background-color: #fff;
`;

export const CardHeader = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
  align-items: center;
`;

export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
  padding-left: 30px;
  padding-top: 30px;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;

export const RightHeader = styled.div`
  width: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-right: 30px;
  padding-top: 30px;
`;

export const CardTitle = styled.h3`
  min-width: max-content;
  margin: 0 40px 0 0;
  font-size: 2.4rem;
  color: #17191c;
  font-weight: 600;
`;

export const CardContent = styled.div`
  width: 100%;
  padding: 0px 30px;
`;

export const ErrorWrapper = styled.div`
  display: flex;
  color: black;
  justify-content: center;
`;
